import { React, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Header } from '../Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';
import { Col, Row, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// import { useDispatch, useSelector } from 'react-redux';
import { useSelector } from 'react-redux';
import { settingData } from '../../../store/features/settingSlice';
import { isMobileOrTablet } from '../../../../helpers/commonHelpers';
import { useLocation } from 'react-router-dom';
import { loader } from '../../../store/features/loaderSlice';
import ListShimmer from '../../../pages/PageShimmers/ListShimmer';
import { setSingleStoredData } from '../../../../helpers/localStorageHelper';

const LogoUrlFront = () => {
  const getSettingData = useSelector(settingData);
  return (
    <img
      src={getSettingData.dashboard_logo}
      alt="logo"
      width={'100%'}
      className="nav-brand popup_img"
    />
  );
};
const PrivateLayout = (props) => {
  const classRef = useRef(null);

  const checkLoading = useSelector(loader);
  const { t } = useTranslation();
  const location = useLocation();
  const [pageClass, setPageClass] = useState('');

  const [isActive, setActive] = useState(() => {
    if (isMobileOrTablet()) {
      return false;
    }
    if (localStorage.isSidebarFullOrNot == undefined) {
      localStorage.isSidebarFullOrNot = true;
    }
    return JSON.parse(localStorage.isSidebarFullOrNot);
  });
  const toggleClass = () => {
    localStorage.isSidebarFullOrNot = !isActive;
    setActive(!isActive);
  };

  useEffect(() => {
    setActive(
      isMobileOrTablet() ? !isMobileOrTablet() : JSON.parse(localStorage.isSidebarFullOrNot)
    );
  }, [location]);

  useEffect(() => {
    setActive(
      isMobileOrTablet() ? !isMobileOrTablet() : JSON.parse(localStorage.isSidebarFullOrNot)
    );
  }, []);

  const routeClassMap = {
    projects: 'project-page',
    dashboard: 'dashboard-page',
    'punch-in-out': 'punch-in-out-wrapper',
    '/attendance': 'attendance-page-wrapper',
    translations: 'translation-page-wrapper',
    'email-template': 'email_template-page-wrapper',
    'faq-category': 'faq_category-page-wrapper',
    faq: 'faq-page-wrapper',
    setting: 'setting-page-wrapper',
    'reports/public': 'public-reports-page-wrapper',
    'reports/private': 'private-report-page-wrapper',
    profile: 'my-profile-wrapper',
    roles: 'roles-page-wrapper',
    user: 'user-page-wrapper',
    'holidays-etc': 'holidays-page-wrapper',
    branch: 'branch-page-wrapper',
    department: 'department-page-wrapper',
    'recruitment-interview-status': 'interview-status-page-wrapper',
    'recruitment-candidate-skills': 'recruitment-skill-page-wrapper',
    'recruitment-candidate-sources': 'recruitment-source-page-wrapper',
    'recruitment-cities': 'recruitment-cities-page-wrapper',
    'recruitment-candidate-companies': 'recruitment-companies-page-wrapper',
    'job-position': 'job-position-page-wrapper',
    'hr-scoring': 'hr-scoring-page-wrapper',
    'hr-scoring-parameters': 'job-position-page-wrapper',
    'skill-scoring-parameters': 'skill-scoring-parameters-page-wrapper',
    'skills-scoring-options': 'skills-scoring-options-page-wrapper',
    myalltasks: 'my-all-task-page',
    'all-sprint': 'all-sprint-page',
    // Add more as needed
  };

  const updateDivWidth = () => {
    const width = classRef.current?.getBoundingClientRect().width ?? 0;
    setSingleStoredData('custom-div-width', width);
  };

  useEffect(() => {
    const foundKey = Object.keys(routeClassMap).find((key) => location.pathname.includes(key));
    setPageClass(foundKey ? routeClassMap[foundKey] : '');
  }, [location.pathname]);

  useEffect(() => {
    // Initial width check
    updateDivWidth();
    // Add event listener
    window.addEventListener('resize', updateDivWidth);
    // Clean up
    return () => {
      window.removeEventListener('resize', updateDivWidth);
    };
  }, [location.pathname]);

  // Custom class added for exclude new-design-bg class implementation
  const excludeClassRoutes = [
    '/dashboard',
    // Add more paths here to avoid new-design-bg class
  ]; 
  const excludeBgClass = excludeClassRoutes.some((route) => location.pathname.startsWith(route));

  let bodyElement = document.getElementsByTagName('body')[0];
  bodyElement.className = isActive ? 'overly bg-main' : 'bg-main';

  return (
    <div {...props} className={checkLoading ? 'd-none' : 'd-block'}>
      <Header isActive={isActive} toggleClass={toggleClass} t={t} />
      <div
        id="wrapper"
        className={`d-flex ${isActive ? 'toggled main-content-wrapper' : 'main-content-wrapper'}`}>
        <Sidebar toggleClass={toggleClass} active={isActive} t={t} />
        <section
          id="content-wrapper"
          className={`section-wrapper ${excludeBgClass ? '' : 'new-design-bg'}`}>
          <Stack className={pageClass} ref={classRef}>
            {props.children}
          </Stack>
        </section>
      </div>
    </div>
  );
};
PrivateLayout.propTypes = {
  children: PropTypes.any.isRequired,
  active: PropTypes.string
};

const StarForRequiredFields = () => {
  return <span style={{ color: 'red' }}>*</span>;
};
export { PrivateLayout, LogoUrlFront, StarForRequiredFields };
